(function() {
  'use strict';

  angular.module('ringbaPortal').component('campaignIntegration', {
    bindings: {
      affiliateNumbers: '<',
      integrationSettingsIdsMap: '<',
      jsTags: '<',
      onUpdate: '&'
    },
    controller: CampaignIntegrationController,
    controllerAs: 'vm',
    templateUrl:
      '/scripts/components/campaign-integration/campaign-integration.view.html'
  });

  function CampaignIntegrationController(
    _,
    $uibModal,
    $scope,
    isMobileDevice,
    accountsService,
    integrationService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.showIntegrationSettings = false;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.hideForm = hideForm;
    vm.showForm = showForm;
    vm.onSave = onSave;
    vm.activateIntegrationSettingActions = activateIntegrationSettingActions;
    vm.confirmDeleteModal = confirmDeleteModal;
    vm.confirmDeleteNumberIntegration = confirmDeleteNumberIntegration;
    vm.cancelModal = cancelModal;
    vm.getPlatformLabel = integrationService.getPlatformLabel;
    vm.getDefaultDelayTime = integrationService.getDefaultDelayTime;
    vm.getConversionSetName = getConversionSetName;

    function onInit() {
      vm.isMobileView = isMobileDevice;
      _loadIntegrations();
    }

    function onChanges(changes) {
      if (
        (changes.affiliateNumbers && vm.affiliateNumbers) ||
        (changes.jsTags && vm.jsTags)
      ) {
        vm.integrationSettings = [];
        vm.integrationSettings = _filterIntegratedNumbers(vm.affiliateNumbers);
        vm.integrationSettings = vm.integrationSettings.concat(
          _filterJsTags(vm.jsTags)
        );
      }

      vm.showIntegrationSettings =
        vm.integrationSettings && vm.integrationSettings.length;
    }

    function showForm(integrationSetting) {
      if (!vm.formActive) {
        if (integrationSetting) {
          integrationSetting.showEditForm = true;
        } else {
          vm.showAddNewForm = true;
        }
        vm.activeActionIntegrationSettingId = false;
        vm.formActive = true;
      }
    }

    function hideForm(event, integrationSetting) {
      if (integrationSetting) {
        integrationSetting.showEditForm = false;
      } else {
        vm.showAddNewForm = false;
      }
      vm.formActive = false;
    }

    function onSave(integrationSetting) {
      hideForm(null, integrationSetting);

      vm.onUpdate();
    }

    function confirmDeleteNumberIntegration() {
      return integrationService
        .deleteIntegrationSetting(
          accountsService.currentAccountId,
          vm.integrationSettingForDelete.id
        )
        .then(function() {
          cancelModal();
          toaster.pop(
            'success',
            'Integration for the number deleted successfully'
          );
          vm.onUpdate();
        });
    }

    function confirmDeleteModal(numberIntegration) {
      if (!vm.formActive) {
        vm.integrationSettingForDelete = numberIntegration;
        vm.modal = $uibModal.open({
          templateUrl:
            '/scripts/components/campaign-integration/delete-campaign-integration.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function getConversionSetName(integrationSetting) {
      if (
        integrationSetting.conversionSet &&
        integrationSetting.conversionSet.name
      ) {
        return integrationSetting.conversionSet.name;
      } else {
        return 'Pixel: ' + integrationSetting.configuration['pixelId'];
      }
    }

    function activateIntegrationSettingActions(integrationId) {
      if (!vm.formActive) {
        vm.activeActionIntegrationSettingId =
          vm.activeActionIntegrationSettingId == integrationId
            ? false
            : integrationId;
      }
    }

    function cancelModal() {
      vm.modal.close();
      vm.modal = null;
      vm.integrationSettingForDelete = null;
    }

    function _loadIntegrations() {
      integrationService
        .getIntegrations(accountsService.currentAccountId)
        .then(function(response) {
          vm.allIntegrations = _.filter(response.data.integrations, {
            status: 'Completed'
          });
        })
        .catch(utils.errorHandler);
    }

    function _filterIntegratedNumbers(numbers) {
      return _.reduce(
        numbers,
        function(finalResult, number) {
          finalResult = _fetchIntegrationSettingsForObject(
            number,
            finalResult,
            function(tempSetting, integrationSetting, number) {
              _.merge(tempSetting, integrationSetting, {
                phoneNumber: number.phoneNumber,
                numberId: number.id,
                offlineUploadDelay: _getOfflineUploadDelay(integrationSetting),
                showIntegration: true
              });
            }
          );

          return finalResult;
        },
        []
      );
    }

    function _filterJsTags(jsTags) {
      return _.reduce(
        jsTags,
        function(finalResult, jsTag) {
          finalResult = _fetchIntegrationSettingsForObject(
            jsTag,
            finalResult,
            function(tempSetting, integrationSetting, jsTag) {
              _.merge(tempSetting, integrationSetting, {
                jsTagName: jsTag.name,
                jsTagId: jsTag.id,
                offlineUploadDelay: _getOfflineUploadDelay(integrationSetting),
                showIntegration: true
              });
            }
          );
          return finalResult;
        },
        []
      );
    }

    function _fetchIntegrationSettingsForObject(
      object,
      finalArray,
      copyIntSettingDetails
    ) {
      _.forEach(object.intSettingIds, function(integrationSettingId) {
        const tempSetting = {};

        const integrationSetting =
          vm.integrationSettingsIdsMap?.[
            utils.capFirstNLetters(integrationSettingId, 5)
          ];

        if (integrationSetting) {
          copyIntSettingDetails(tempSetting, integrationSetting, object);
        }

        finalArray = _.isEmpty(tempSetting)
          ? finalArray
          : finalArray.concat(tempSetting);
      });

      _.forEach(object.integrationSettings, function(integrationSetting) {
        const tempSetting = {};

        copyIntSettingDetails(tempSetting, integrationSetting, object);

        finalArray = _.isEmpty(tempSetting)
          ? finalArray
          : finalArray.concat(tempSetting);
      });

      return finalArray;
    }

    function _getOfflineUploadDelay(integrationSetting) {
      try {
        return parseInt(
          (integrationSetting &&
            integrationSetting.configuration['offlineUploadDelay']) ||
            vm.getDefaultDelayTime(
              integrationSetting.integration.type,
              integrationSetting.callerIdOnlyConversion ? 'number' : 'jstag'
            )
        );
      } catch {
        return undefined;
      }
    }
  }
})();
